// store/useAuthStore.ts
import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { createFinconnectSlice, type FinconnectActions } from './createFinconnectSlice';
import { finconnectInitialState, type FinconnectState } from './finconnectInitialState';

/**
 * @french
 * Hook Zustand persistant pour powens
 */
export const useFinconnectStore = create<FinconnectState & FinconnectActions>()(
  persist(combine(finconnectInitialState, createFinconnectSlice as any), {
    name: 'finconnect-store',
  }),
);
